// import Vue from 'vue'
import DataDict from '@/mixin/dict.js'
// import { getDicts as getDicts } from '@/api/system/dict/data'

function install(vm) {
  vm.use(DataDict, vm)
}

export default {
  install,
}
